import React from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom'
import { Editor } from '@tinymce/tinymce-react';
import { Row, Col, ListGroup } from 'react-bootstrap'
import ReactTooltip from 'react-tooltip';
import './testniJS.js'
import qrCodeGenerator from 'qrcode-generator'
import { store } from 'react-notifications-component';

export class TinyMce extends React.Component{
    state={
        tinyMce: '',
        preview: '',
        primjerRacuna: [
            {
                "name" : "uuid",
                "value": "5252c133-d8dd-4766-a327-4d52e6c24a5c"
            },
            {"name" :"fiscalization_request_uuid","value":"41b10c50-653b-11eb-bb5a-1f9397e1c9c2"},
            {"name" :"client_name","value":"Testna tvrtka d.o.o."},
            {"name" :"client_address","value":"Borongajska 81a, Zagreb, 10000 Zagreb"},
            {"name" :"client_oib","value":"01234567890"},
            {"name" :"invoice_date","value":"01.01.2000. 00:00:00"},
            {"name" :"invoice_business_premises_label","value":"Poslovni prostor"},
            {"name" :"invoicebusinesspremises","value":"Poslova ulica 1, Split, 21000 Split"},
            {"name" :"invoice_billing_device_isu","value":"111111110"},
            {"name" :"ZKI","value":"84ef8e29b4b6db1b7e77b34594e014c3"},
            {"name" :"JIR","value":"7ff8d4d8-acda-4b64-95bb-02cb4aee7edd"},
            {"name" :"invoice_no","value":"00001"},
            {"name" :"means_of_payment","value":"Gotovina"},
            {"name" :"items",
                "value": [
                    {
                    "uuid":"3ff1af52-268a-45a6-91b9-26fd17b93e3d",
                    "article_request_uuid":"41b10c51-653b-11eb-bb5a-1f9397e1c9c2",
                    "article":"Predmet 1",
                    "quantity":"2.00",
                    "single_unit_retail_price":"100.00",
                    "total_amount":"200.00",
                    "tax_rate":"25.00",
                    "base_price":"160.00",
                    "tax_amount":"40.00"
                },{
                    "uuid":"3ff1af52-268a-45a6-91b9-26fd17b93e3d",
                    "article_request_uuid":"41b10c51-653b-11eb-bb5a-1f9397e1c9c2",
                    "article":"Predmet 2",
                    "quantity":"1.00",
                    "single_unit_retail_price":"200.00",
                    "total_amount":"200.00",
                    "tax_rate":"25.00",
                    "base_price":"160.00",
                    "tax_amount":"40.00"
                    }
                ],
            },
            { "name": "tax",
                "value":[{
                "uuid":"6e8966e3-7dea-46d7-a70b-f708f2448894",
                "tax_rate":"25.00",
                "tax_base":"320.00",
                "tax_amount":"80.00"
                }],
            },
            { "name": "invoice_amount", "value":"400.00"},
            { "name": "in_VAT_system", "value":"true"}
        ],
        varijable:[
            { "name": "client_name", "opis": "Naziv Klijenta"},
            { "name": "client_address", "opis": "Adresa Klijenta"},
            { "name": "client_oib", "opis": "OIB Klijenta"},
            { "name": "invoice_date", "opis": "Datum i vrijeme izdavanja računa"},
            { "name": "invoice_business_premises_label", "opis": "Naziv poslovnog prostora"},
            { "name": "invoicebusinesspremises", "opis": "Adresa poslovnog prostora"},
            { "name": "invoice_billing_device_isu", "opis": "ISU naplatnog uređaja"},
            { "name": "ZKI", "opis": "Zaštitni Kod Izdavatelja"},
            { "name": "JIR", "opis": "Jedinstveni Identifikator Računa"},
            { "name": "invoice_no", "opis": "Redni broj računa"},
            { "name": "means_of_payment", "opis": "Način plaćanja"},
            { "name": "invoice_amount", "opis": "Iznos Računa"},
            { "name": "in_VAT_system", "opis": "U sustavu poreza"},
            { "name": "qrCode", "opis": "QR kod kreiran za ovaj račun"},           
            { "name": "#items", "opis": "Artikli/Usluge"},     
            { "name": "article", "opis": "Naziv artikla"},
            { "name": "quantity", "opis": "Količina artikala"},
            { "name": "single_unit_retail_price", "opis": "Jedinična cijena artikla"},
            { "name": "total_amount", "opis": "Ukupni iznos artikla"},
            { "name": "item_tax_rate", "opis": "Visina poreza za artikla"},
            { "name": "base_price", "opis": "Osnovica artikla"},
            { "name": "item_tax_amount", "opis": "Iznos poreza za artikl"},
            { "name": "/items", "opis": "Porezi početak liste"},
            { "name": "#tax", "opis": "Porezi početak liste"},
            { "name": "tax_rate", "opis": "Visina poreza"},
            { "name": "tax_base", "opis": "Osnovica za oporzivanje"},
            { "name": "tax_amount", "opis": "Iznos poreza"},
            { "name": "/tax", "opis": "Porezi završetak liste"}
        ]
    }

    serachForString = async () =>{
        await this.state.varijable.map((data, index) => {
            if(this.state.preview !== null && this.state.preview.indexOf('{' + data.name + '}') !== -1){ 
                this.state.primjerRacuna.map((data2, index2) => {
                    if(data2.name === data.name){
                        var SampleText = this.state.preview; 
                        var NewText = SampleText.replaceAll('{' + data.name + '}', data2.value);
                        this.setState({ preview : NewText});
                    }
                    return null
                })              
                document.getElementById('{' + data.name + '}').classList.add("line_trough")
            }
            else{
                document.getElementById('{' + data.name + '}').classList.remove("line_trough")
            }
            return null
        })

        //tax checker
        if(this.state.preview !== null && this.state.preview.indexOf('{#tax}') !== -1 && this.state.preview.indexOf('{/tax}') !== -1){
            var pocetak = this.state.preview.indexOf("{#tax}");
            var kraj = this.state.preview.indexOf("{/tax}");

            let HTMLtax = this.state.preview.substr(pocetak + 11, kraj - 4 - pocetak - 11 )

            // check if table
            if(HTMLtax.indexOf('table') !== -1){
                let brojRedakaTablice = (HTMLtax.split("tr").length - 1) / 2 //djelit sa 2 jer jedan red ima open and close tag

                let redakKojiJeTax = 0 // 0 = tax varaiables not in table
                let i = 1
                let pocetakRetka
                let krajRetka
                let HTMLredak
                let taxesHTMLafterLoop = ''
                // loop trough each row   
                if(redakKojiJeTax === 0 ){

                    for(i; i <= brojRedakaTablice; i++){
                        pocetakRetka = this.getPosition(this.state.preview, 'tr', i*2-1) - 1 
                        krajRetka = this.getPosition(this.state.preview, 'tr', i*2)  + 4
                        HTMLredak = this.state.preview.substr(pocetakRetka, krajRetka - pocetakRetka)
                        if(HTMLredak.indexOf('{tax_rate}') !== -1 ||  HTMLredak.indexOf('{tax_base}') !== -1 || HTMLredak.indexOf('{tax_amount}') !== -1){
                            console.log("nasao na retku broj: ", i)
                            redakKojiJeTax = i                                
                        } 
                    }
                } 
                // if redakKojiJeTax = 0 there is no variables so stop
                if(redakKojiJeTax !== 0){
                    //get redak koji ima varijable
                    pocetakRetka = this.getPosition(this.state.preview, 'tr', redakKojiJeTax*2-1) - 1 
                    krajRetka = this.getPosition(this.state.preview, 'tr', redakKojiJeTax*2)  + 4
                    HTMLredak = this.state.preview.substr(pocetakRetka, krajRetka - pocetakRetka)

                    //loop trough all taxes
                    this.state.primjerRacuna[14].value.map((data, index) => {                    
                        let noviRedak = HTMLredak
                        if(noviRedak.indexOf('{tax_rate}') !== -1){                        
                            noviRedak = noviRedak.replaceAll('{tax_rate}', data.tax_rate)                                
                        }
                        if(noviRedak.indexOf('{tax_base}') !== -1){
                            noviRedak = noviRedak.replaceAll('{tax_base}', data.tax_base)
                        }
                        if(noviRedak.indexOf('{tax_amount}') !== -1){
                            noviRedak = noviRedak.replaceAll('{tax_amount}', data.tax_amount)
                        }
                        taxesHTMLafterLoop += taxesHTMLafterLoop + noviRedak

                        return null
                    })

                    //rascjepaj string na 2 djela i ubaci fromatirani text
                    pocetakRetka = this.getPosition(this.state.preview, 'tr', redakKojiJeTax*2-1) - 1 
                    krajRetka = this.getPosition(this.state.preview, 'tr', redakKojiJeTax*2)  + 4
                    let pocetakStringa = this.state.preview.substr(0, pocetakRetka)    
                    let krajStringa = this.state.preview.substr(krajRetka , this.state.preview.length)                        
                    let konacniHTML = pocetakStringa + taxesHTMLafterLoop + krajStringa

                    //replace occurance of #tax and /tax
                    konacniHTML = konacniHTML.replaceAll("{#tax}", "")
                    konacniHTML = konacniHTML.replaceAll("{/tax}", "")
                    this.setState({ preview : konacniHTML});
                }
            }

            //ako nije tablica
            else{
                var taxesHTMLafterLoop = ""


                this.state.primjerRacuna[14].value.map((data, index) => {                    
                    let noviRedak = HTMLtax
                    if(noviRedak.indexOf('{tax_rate}') !== -1){                        
                        noviRedak = noviRedak.replaceAll('{tax_rate}', data.tax_rate)  
                    }
                    if(noviRedak.indexOf('{tax_base}') !== -1){
                        noviRedak = noviRedak.replaceAll('{tax_base}', data.tax_base)
                    }
                    if(noviRedak.indexOf('{tax_amount}') !== -1){
                        noviRedak = noviRedak.replaceAll('{tax_amount}', data.tax_amount)
                    }
                    taxesHTMLafterLoop = taxesHTMLafterLoop + noviRedak

                    return null
                })
                // makni #tax i /tax iz stringa
                let odrezaniString = this.state.preview.substr(pocetak , kraj - pocetak)
                console.log("odrezaniString: ", odrezaniString) 
                let carouselLeftZnakIzaTax = odrezaniString.indexOf("<")
                let carouselRightZnakIzaTax = odrezaniString.indexOf(">")
                let znakizaTaxElementa = odrezaniString.substr(carouselLeftZnakIzaTax, carouselRightZnakIzaTax - carouselLeftZnakIzaTax + 1)
                let znakIspredTaxElementa = znakizaTaxElementa.replace("/" , "")
                console.log("pocetak: ", pocetak) 
                console.log("kraj: ", kraj) 
                console.log("znakizaTaxElementa: ", znakizaTaxElementa) 
                console.log("znakIspredTaxElementa: ", znakIspredTaxElementa) 
                        
                let prviDio = this.state.preview.substr(0 , pocetak + "{#tax}".length + znakizaTaxElementa.length)
                console.log(prviDio)
                let treciDio = this.state.preview.substr(kraj - znakIspredTaxElementa.length, this.state.preview.length)
                console.log(treciDio)

                let konacniHTML = prviDio + taxesHTMLafterLoop + treciDio

                konacniHTML = konacniHTML.replace( znakIspredTaxElementa + "{#tax}" + znakizaTaxElementa, "")                
                konacniHTML = konacniHTML.replace( znakIspredTaxElementa + "{/tax}" + znakizaTaxElementa, "")
                console.log(konacniHTML)

                this.setState({
                    preview: konacniHTML
                })
                
                
            }
        }

        //items checker
        if(this.state.preview !== null && this.state.preview.indexOf('{#items}') !== -1 && this.state.preview.indexOf('{/items}') !== -1){
            pocetak = this.state.preview.indexOf("{#items}");
            kraj = this.state.preview.indexOf("{/items}");

            let HTMLitem = this.state.preview.substr(pocetak + 12, kraj - 4 - pocetak - 11 )
            console.log(HTMLitem)

            // check if table
            if(HTMLitem.indexOf('table') !== -1){
                let brojRedakaTablice = (HTMLitem.split("tr").length - 1) / 2 //djelit sa 2 jer jedan red ima open and close tag

                let redakKojiJeArticle = 0 // 0 = tax varaiables not in table
                let i = 1
                let pocetakRetka
                let krajRetka
                let HTMLredak
                let taxesHTMLafterLoop = ''
                // loop trough each row   
                if(redakKojiJeArticle === 0 ){

                    for(i; i <= brojRedakaTablice; i++){

                        console.log(i)
                        pocetakRetka = this.getPosition(this.state.preview, 'tr', i*2-1) - 1 
                        krajRetka = this.getPosition(this.state.preview, 'tr', i*2)  + 4
                        HTMLredak = this.state.preview.substr(pocetakRetka, krajRetka - pocetakRetka)
                        console.log("HTMLredak")
                        console.log(HTMLredak)
                        if(HTMLredak.indexOf('{article}') !== -1 ||  
                            HTMLredak.indexOf('{quantity}') !== -1 || 
                            HTMLredak.indexOf('{single_unit_retail_price}') !== -1 ||
                            HTMLredak.indexOf('{total_amount}') !== -1 || 
                            HTMLredak.indexOf('{item_tax_rate}') !== -1 ||
                            HTMLredak.indexOf('{item_tax_amount}') !== -1)
                            {
                                console.log("nasao na retku broj: ", i)
                                redakKojiJeArticle = i                                
                            } 
                    }
                } 
                // if redakKojiJeArticle = 0 there is no variables so stop
                if(redakKojiJeArticle !== 0){
                    //get redak koji ima varijable
                    pocetakRetka = this.getPosition(this.state.preview, 'tr', redakKojiJeArticle*2-1) - 1 
                    krajRetka = this.getPosition(this.state.preview, 'tr', redakKojiJeArticle*2)  + 4
                    HTMLredak = this.state.preview.substr(pocetakRetka, krajRetka - pocetakRetka)

                    //loop trough all items
                    this.state.primjerRacuna[13].value.map((data, index) => {    
                        console.log(index)                
                        let noviRedak = HTMLredak
                        if(noviRedak.indexOf('{article}') !== -1){                        
                            noviRedak = noviRedak.replaceAll('{article}', data.article)                                
                        }
                        if(noviRedak.indexOf('{quantity}') !== -1){
                            noviRedak = noviRedak.replaceAll('{quantity}', data.quantity)
                        }
                        if(noviRedak.indexOf('{single_unit_retail_price}') !== -1){
                            noviRedak = noviRedak.replaceAll('{single_unit_retail_price}', data.single_unit_retail_price)
                        }
                        if(noviRedak.indexOf('{total_amount}') !== -1){
                            noviRedak = noviRedak.replaceAll('{total_amount}', data.total_amount)
                        }
                        if(noviRedak.indexOf('{item_tax_rate}') !== -1){
                            noviRedak = noviRedak.replaceAll('{item_tax_rate}', data.tax_rate)
                        }
                        if(noviRedak.indexOf('{item_tax_amount}') !== -1){
                            noviRedak = noviRedak.replaceAll('{item_tax_amount}', data.tax_amount)
                        }
                        if(noviRedak.indexOf('{base_price}') !== -1){
                            noviRedak = noviRedak.replaceAll('{base_price}', data.base_price)
                        }

                        taxesHTMLafterLoop = taxesHTMLafterLoop + noviRedak

                        return null
                    })

                    //rascjepaj string na 2 djela i ubaci fromatirani text
                    pocetakRetka = this.getPosition(this.state.preview, 'tr', redakKojiJeArticle* 2 - 1 ) - 1 
                    krajRetka = this.getPosition(this.state.preview, 'tr', redakKojiJeArticle * 2 ) + 4
                    let pocetakStringa = this.state.preview.substr(0, pocetakRetka)    
                    let krajStringa = this.state.preview.substr(krajRetka , this.state.preview.length)                        
                    let konacniHTML = pocetakStringa + taxesHTMLafterLoop + krajStringa

                    //replace occurance of #tax and /tax
                    konacniHTML = konacniHTML.replaceAll("{#items}", "")
                    konacniHTML = konacniHTML.replaceAll("{/items}", "")
                    this.setState({ preview : konacniHTML});
                }
            }
            //ako nije tablica
            else{
                taxesHTMLafterLoop = ""

                //loop trough all items
                this.state.primjerRacuna[13].value.map((data, index) => {                    
                    let noviRedak = HTMLitem
                    if(noviRedak.indexOf('{article}') !== -1){                        
                        noviRedak = noviRedak.replaceAll('{article}', data.article)                                
                    }
                    if(noviRedak.indexOf('{quantity}') !== -1){
                        noviRedak = noviRedak.replaceAll('{quantity}', data.quantity)
                    }
                    if(noviRedak.indexOf('{single_unit_retail_price}') !== -1){
                        noviRedak = noviRedak.replaceAll('{single_unit_retail_price}', data.single_unit_retail_price)
                    }
                    if(noviRedak.indexOf('{total_amount}') !== -1){
                        noviRedak = noviRedak.replaceAll('{total_amount}', data.total_amount)
                    }
                    if(noviRedak.indexOf('{item_tax_rate}') !== -1){
                        noviRedak = noviRedak.replaceAll('{item_tax_rate}', data.tax_rate)
                    }
                    if(noviRedak.indexOf('{item_tax_amount}') !== -1){
                        noviRedak = noviRedak.replaceAll('{item_tax_amount}', data.tax_amount)
                    }
                    if(noviRedak.indexOf('{base_price}') !== -1){
                        noviRedak = noviRedak.replaceAll('{base_price}', data.base_price)
                    }

                    taxesHTMLafterLoop = taxesHTMLafterLoop + noviRedak

                    return null
                })
                // makni #tax i /tax iz stringa
                let odrezaniString = this.state.preview.substr(pocetak , kraj - pocetak)
                let carouselLeftZnakIzaTax = odrezaniString.indexOf("<")
                let carouselRightZnakIzaTax = odrezaniString.indexOf(">")
                let znakizaTaxElementa = odrezaniString.substr(carouselLeftZnakIzaTax, carouselRightZnakIzaTax - carouselLeftZnakIzaTax + 1)
                let znakIspredTaxElementa = znakizaTaxElementa.replace("/" , "")
                let prviDio = this.state.preview.substr(0 , pocetak + "{#items}".length + znakizaTaxElementa.length + 1)
                let treciDio = this.state.preview.substr(kraj - znakIspredTaxElementa.length, this.state.preview.length)
                let konacniHTML = prviDio + taxesHTMLafterLoop + treciDio
                konacniHTML = konacniHTML.replace( znakIspredTaxElementa + "{#items}" + znakizaTaxElementa, "")      
                konacniHTML = konacniHTML.replace( znakIspredTaxElementa + "{/items}" + znakizaTaxElementa, "")

                this.setState({
                    preview: konacniHTML
                })
            }
        }
    }

    getPosition(string, subString, index) {
        return string.split(subString, index).join(subString).length;
      }

    insertVariable = async (e) => {
        await window.tinymce.execCommand('mceInsertContent', false , e.target.id); 
        await this.serachForString()  
       
          
        if(this.state.preview.indexOf('{qrCode}') !== -1){
            let qrString = await this.qrString()

            var typeNumber = 0;
            var errorCorrectionLevel = 'L';
            var qr = qrCodeGenerator(typeNumber, errorCorrectionLevel);
            qr.addData(qrString);
            qr.make();
            
            var SampleText = this.state.preview; 
            var NewText = SampleText.replaceAll('{qrCode}', qr.createImgTag(4));
            await this.setState({ preview : NewText});  
        }
    }

    qrString(){
        const zki = "84ef8e29b4b6db1b7e77b34594e014c3"
        let datum = "01.01.2000. 00:00:00".split(" ")[0]
        let dan = datum.split(".")[0]
        let mjesec = datum.split(".")[1]
        let godina = datum.split(".")[2]
        let vrijeme = "01.01.2000. 00:00:00".split(" ")[1]
        let sati = vrijeme.split(":")[0]
        let minute = vrijeme.split(":")[1]
        let customDatum = godina+mjesec+dan+"_"+sati+minute

        const poreznaURL = "https://porezna.gov.hr/rn?"
        const iznos = "400,00"
    
        let total = poreznaURL + "zki=" + zki + "&datv=" + customDatum + "&izn=" + iznos        
        return total//<QRCode value={total} renderAs={'svg'}/>
    }

    handleEditorChange = (content) => {
        this.setState({
            tinyMce: content,
            preview: content
        })
        this.serachForString()
    }

    savePredlozak(){      

        if(this.state.tinyMce.length !== 0){
            this.props.mapState("CUSTOM_INVOICE_FILE", this.state.tinyMce)

            store.addNotification({
                title: "Uspješno!",
                message: "Predložak je uspješno spremljen",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  pauseOnHover: true
                }
            });
    
            this.props.history.goBack()
        }
        else{
            store.addNotification({
                title: "Greška!",
                message: "Predložak je prazan",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  pauseOnHover: true
                }
            });
        }
        
    }

    componentDidMount = async () => {
        await this.setState({
            preview: this.props.customInvoiceFile
        })
        this.serachForString()
    }

    render() {
        return (
            <main style={{height: "auto"}}>
                <header>
                    <h1>
                        Predložak Računa
                    </h1>
                </header>
                <div className="container">
                    <div className="row">
                        <div className="col">     
                            <Row> 
                                <Col>                              
                                    <ListGroup horizontal>
                                        {this.state.varijable.map((data,index) => 
                                         
                                            /*data.name === "#items" || data.name === "#tax" ? <><br key={Math.random()}/><br key={Math.random()}/></> : null */
                                            <ListGroup.Item key={index} id={'{' + data.name + '}'}>
                                                <a data-tip 
                                                    data-for={'{'+ data.name + '}' }
                                                    id={'{' + data.name + '}'}
                                                    onClick={(e) => this.insertVariable(e)}
                                                >
                                                    {data.name}
                                                </a>
                                                <ReactTooltip id={'{' + data.name + '}'} type='info' effect="solid" key={Math.random()}>
                                                    <span>{data.opis}</span>
                                                </ReactTooltip>                                            
                                            </ListGroup.Item>
                                           
                                        )}                                    
                                    </ListGroup> 
                                </Col> 
                            </Row>
                            
                            <br/>

                            <Row>
                                <Col> 
                                    <Editor
                                        id="testniTinyMce"
                                        apiKey='7kle6hlsp7xilu6f99siuq6xs56qthnd745ku5q19kqf2a6r'
                                        initialValue={this.props.customInvoiceFile}                                            
                                        init={{ 
                                            height: 500,  
                                            //width: "210mm",
                                            language: 'hr',
                                            plugins: [
                                                'advlist autolink lists link image charmap preview hr',
                                                'searchreplace wordcount visualblocks visualchars',
                                                'media table contextmenu directionality',
                                                'emoticons paste textcolor colorpicker textpattern imagetools'
                                            ],
                                            toolbar:
                                                'undo redo | fontsizeselect | bold italic backcolor | \
                                                alignleft aligncenter alignright alignjustify | \
                                                bullist numlist outdent indent | ',
                                            images_upload_url: 'postAcceptor.php',
                                            automatic_uploads: false,
                                            fontsize_formats: "8pt 10pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 26pt 28pt 30pt 32pt 34pt 36pt",                                                
                                        }}

                                        onEditorChange={this.handleEditorChange}             
                                        
                                    /> 
                                </Col>
                            </Row>

                            <br/>
                            <br/>

                            <Row>
                                <Col>
                                    <div className="btn btn-info" onClick={() => this.savePredlozak()}>
                                        Spremi Predložak
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>

                    <br/>
                    <br/>
                    <br/>

                    <h2 style={{width: "200px", borderBottom: "1px solid lightgray"}}>Izgled računa (A4)</h2>         
                    <br/>
                    <div className="primjerRacunaPreview" dangerouslySetInnerHTML={{__html: this.state.preview}}></div>

                </div>
            </main>
                
        )

      }
     
}

const mapStateToProps = state => {
    return {
        userLoggedIn: state.client.userLoggedIn,
        asideColapsed: state.clientSettings.asideColapsed,
        asideBg: state.clientSettings.asideBg,
        darkTheme: state.clientSettings.darkTheme,
        generickiPredlozakRacuna: state.clientSettings.generickiPredlozakRacuna,
        customInvoiceFile: state.clientSettings.customInvoiceFile
    };
  };
  
  const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data}),
      toggleSettings: (type) => dispatch({ type: type})  
    };
  };
  
  
  
  export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
  )(TinyMce));
